import { NgModule } from '@angular/core';
import {
    AdvancedSelectFolderComponent,
    BreadcrumbComponent, CfnEcmItemListComponent,
    CfnEcmItemGridComponent,
    CfnEcmItemDetailsComponent,
    CfnEcmDownloadButtonComponent,
    CfnEcmSelectionDetailsComponent,
    SelectFolderComponent,
    SelectSortComponent,
    SelectSpaceComponent,
    ThemedAutocompleteComponent,
    DateInputComponent,
    ViewModeButtonComponent, NotificationsComponent, MetaDataFormComponent,
    CustomMetadataEditorComponent,
    MetadataGroupsEditorComponent,
    ToolbarComponent,
    ToolbarBrandComponent,
} from './components';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogComponent, FolderDetailsDialogComponent, RenameDocumentsComponent, SessionExpiredDialogComponent, DocumentPropertiesComponent, UpdateNoticeDialogComponent } from './dialogs';
import { AddDocumentFolderDialogComponent } from './dialogs';
import { SharedModule, SmexLibCommonFrontendModule } from '@numen/smex-lib-common-frontend';
import { CfnEcmItemIconComponent } from './components';
import { LibCfnEcmCoreModule } from '../core/core.module';
import { AddMetaDataComponent } from './dialogs/add-metadata/add-metada.component';
import { FileSizePipe } from './pipes/file-size.pipe';
import { RouterModule } from '@angular/router';
import { ApiService } from './services/api/api.service';
import { NumbersWithSpacePipe } from './pipes/numbers-with-space.pipe';


@NgModule({
    declarations: [
        CfnEcmItemIconComponent,
        CfnEcmItemListComponent,
        CfnEcmItemGridComponent,
        BreadcrumbComponent,
        CfnEcmItemDetailsComponent,
        CfnEcmDownloadButtonComponent,
        CfnEcmSelectionDetailsComponent,
        FolderDetailsDialogComponent,
        ConfirmDialogComponent,
        ViewModeButtonComponent,
        SelectSpaceComponent,
        ThemedAutocompleteComponent,
        SelectSortComponent,
        SelectFolderComponent,
        AdvancedSelectFolderComponent,
        AddDocumentFolderDialogComponent,
        NotificationsComponent,
        MetaDataFormComponent,
        DateInputComponent,
        CustomMetadataEditorComponent,
        MetadataGroupsEditorComponent,
        AddMetaDataComponent,
        FileSizePipe,
        NumbersWithSpacePipe,
        SessionExpiredDialogComponent,
        DocumentPropertiesComponent,
        RenameDocumentsComponent,
        RenameDocumentsComponent,
        ToolbarComponent,
        ToolbarBrandComponent,
        UpdateNoticeDialogComponent
    ],
    imports     : [
        SmexLibCommonFrontendModule,
        ReactiveFormsModule,
        SharedModule,
        LibCfnEcmCoreModule,
        RouterModule,
        
    ],
    exports     : [
        SmexLibCommonFrontendModule,
        SharedModule,
        CfnEcmItemIconComponent,
        CfnEcmItemListComponent,
        CfnEcmItemGridComponent,
        BreadcrumbComponent,
        CfnEcmItemDetailsComponent,
        CfnEcmDownloadButtonComponent,
        CfnEcmSelectionDetailsComponent,
        FolderDetailsDialogComponent,
        ConfirmDialogComponent,
        ViewModeButtonComponent,
        SelectSortComponent,
        SelectSpaceComponent,
        ThemedAutocompleteComponent,
        SelectFolderComponent,
        NotificationsComponent,
        MetaDataFormComponent,
        DateInputComponent,
        CustomMetadataEditorComponent,
        MetadataGroupsEditorComponent,
        FileSizePipe,
        NumbersWithSpacePipe,
        RenameDocumentsComponent,
        SessionExpiredDialogComponent,
        ToolbarComponent,
        ToolbarBrandComponent,
        UpdateNoticeDialogComponent
    ],
    providers: [ApiService]
})
export class LibCfnEcmSharedModule {
}
